const redirectToJobberOAuth = () => {
  if (import.meta.env.NODE_ENV === "test") return;
  window.location.href = `${import.meta.env.VITE_JOBBER_API_URL}?client_id=${import.meta.env.VITE_JOBBER_APP_CLIENT_ID}&redirect_uri=${import.meta.env.VITE_REDIRECT_URL}`;
};

export default redirectToJobberOAuth;
